import React, { FunctionComponent, useState } from 'react'
import styles from './DateSelect.module.sass'
import DatePicker from '../DatePicker/DatePicker'
import ShadowContainer from '../../../etc/popover/ShadowContainer/ShadowContainer'
import { Modifier } from 'react-day-picker'
import Popover from '../../../etc/Popover'
import {parseDate} from '../../../../utils/date-utils'

interface Props {
    className?: string,
    value?: Date,
    onChange?: (date: Date) => void,
    disabledDays?: Modifier,
    newDeadLineDate?: boolean
    children: (params: {
        date?: Date,
        toggle: () => void,
    }) => JSX.Element,
}

const DateSelect: FunctionComponent<Props> = props => {
    const [open, setOpen] = useState(false)

    let dateResult = props.value
    if(props.newDeadLineDate) {
        const oldDate:any = props.value // eslint-disable-line
        const nowDate:any = new Date() // eslint-disable-line

        dateResult = oldDate < nowDate ? parseDate(nowDate) : props.value
    }

    return <Popover
        padding={0}
        align={'center'}
        isOpen={open}
        onClickOutside={() => setOpen(false)}
        content={<ShadowContainer className={styles.popover}>
            <DatePicker
                value={dateResult}
                disabledDays={props.disabledDays}
                onChange={(date) => {
                    props.onChange?.(date)
                    setOpen(false)
                }}
            />
        </ShadowContainer>}
    >
        {props.children({
            date: props.value,
            toggle: () => setOpen(!open),
        })}
    </Popover>
}

export default DateSelect